
export default {
  name: 'ItemTabDosage',
  props: {
    items: Array,
  },
};
